import axios from 'axios';

const baseUrl = import.meta.env.VITE_SERVER_URL;

// creating an axios instance with auth setup
const axiosInstance = axios.create({
	baseURL: baseUrl,
	timeout: 40000,
});

// adding the request interceptor
axiosInstance.interceptors.request.use((config) => {
	if (config.withCredentials) {
		const deviceId: string | null = localStorage.getItem('device_id');
		if (deviceId) {
			config.headers['Authorization'] = `Token ${deviceId}`;
		}
	}

	return config;
});

//defining the interceptor which will automate the process of refresh and access token
axiosInstance.interceptors.response.use(
	function (response) {
		// Simply returning the response
		return response;
	},
	function (error) {
		return Promise.reject(error);
	},
);

export default axiosInstance;
